module.exports = __webpack_public_path__ + "img/14-small.ab4cdfb9.png";